import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeartDonation: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHeartDonation"><Path d="M12 5.37552C18.5042 -1.25346 29.6544 11.0575 12 21C-5.65441 11.0576 5.4957 -1.25346 12 5.37552Z" stroke="currentColor"/><Path d="M12.012 9.09756V8M12.012 16.2317V17M9.67969 14.4482C10.5159 16.0945 14.0699 16.0047 14.0699 14.1567C14.0699 11.8246 9.88875 12.9453 9.88875 10.561C9.88875 8.9544 12.4614 8.72364 13.6583 9.80164" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHeartDonation;
